import * as ngCdkDragDrop from '@angular/cdk/drag-drop'
import * as ngCore from '@angular/core'

import * as state from '../../../../../../../../state'
import * as componentStore from '../component-store'
import { isLayoutValid } from '../optimize-layout'

@ngCore.Component({
  imports: [ngCdkDragDrop.DragDropModule],
  selector: 'atn-page-builder-segments',
  styleUrls: ['./component.scss'],
  templateUrl: './component.html',
})
export class Component {
  /** @see {@link componentStore.builder.Store} */
  public readonly store = ngCore.inject(componentStore.builder.Store)

  /**
   * Handles the drag-and-drop event when a segment tab is reordered.
   */
  public segmentDropHandler(
    $event: ngCdkDragDrop.CdkDragDrop<state.mosaic.dev.pages.models.Segment[]>,
  ): void {
    this.store.reorderSegments($event.previousIndex, $event.currentIndex)
  }

  /** Handles the click event when the edit segment button is clicked. */
  public editSegmentClickHandler(
    id: state.mosaic.dev.pages.models.Segment.Id,
    $event: Event,
  ): void {
    // Prevents the click event from bubbling up and triggering segment selection
    // or layout validation. Without this, clicking the edit icon would switch to
    // the clicked segment and trigger validation, which is not desired
    // when only editing segment metadata.
    $event.stopPropagation()
    this.store.patchState({
      editingSegmentId: id,
    })
  }

  /**
   * Sets the selected segment as active if the layout is valid. Otherwise prompts
   * for layout optimization confirmation for the current segment.
   */
  public segmentClickHandler(
    segment: state.mosaic.dev.pages.models.Segment,
  ): void {
    if (segment.id === this.store.currentSegmentIdSg()) {
      return
    }
    const grid = this.store.gridSg()

    if (!grid) {
      return
    }

    if (!isLayoutValid(grid, this.store.widgetFrameLookupSg())) {
      this.store.patchState({
        switchingSegmentConfiguration: {
          isNew: false,
          segment,
        },
      })
    } else {
      this.store.setCurrentSegment(segment)
    }
  }
}
